// extracted by mini-css-extract-plugin
export default {"ForumGhostButton":"Nk1LAJw7NrLpy0BX2rqD"};